module.exports = __webpack_public_path__ + "static/media/AdobeSign_Step4_Image27.5102332f.jpg";